export const getAmmounts = (country: any, places: any, airports: any) => {
  const actives =
    country.places.filter((place: any) =>
      places.some(
        (statePlace: any) =>
          statePlace.id === place &&
          statePlace.isVisible &&
          statePlace.isPastPlace
      )
    ).length +
    country.airports.filter((airport: any) =>
      airports.some(
        (stateAirport: any) =>
          stateAirport.id === airport &&
          stateAirport.isVisible &&
          stateAirport.isPastAirport
      )
    ).length;
  return (
    actives +
    "/" +
    (country.places.filter((place: any) => place.isPastPlace).length +
      country.airports.filter((airport: any) => airport.isPastAirport).length)
  );
};

export const getGlyphiconProps = (country: any) => {
  const className = "Kraj_buttonIcon" + (country.isVisible ? "" : "--hidden");
  if (country.isVisible)
    return {
      icon: "visibility",
      className
    };

  return {
    icon: "visibility_off",
    className
  };
};
